import styled from '@emotion/styled';

const Wrapper = styled.div`
  position: absolute;
  left: 0;
  top: 3.5rem;
  z-index: 50;
  margin: 0;
  padding: 0;
  width: 100%;
  max-height: 400px;
  overflow-y: auto;
  background-color: ${({ theme }) => theme.colors.neutral.white100};
  border: 0.125rem solid ${({ theme }) => theme.colors.neutral.grey80};
  border-radius: ${({ theme }) => theme.radius.sm};
  box-shadow:
    0 4px 6px -1px rgb(0 0 0 / 10%),
    0 2px 4px -2px rgb(0 0 0 / 10%);
  font-size: 1rem;
  line-height: 1.5;
  list-style-type: none;
`;

const Headline = styled.div`
  padding: 0.75rem 0.75rem 0.25rem;
  color: ${({ theme }) => theme.colors.neutral.grey120};
  font-size: 0.875rem;
  font-weight: bold;
  letter-spacing: 0.2em;
  text-transform: uppercase;
`;

const List = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;

  li {
    &:not(:first-of-type, :last-of-type) {
      border-top: 1px solid ${({ theme }) => theme.colors.neutral.grey80};
    }
  }
`;

const ItemButton = styled.button`
  margin: 0;
  padding: 0.75rem;
  border: 0;
  width: 100%;
  font: inherit;
  text-align: left;
  color: inherit;
  background: none;
  cursor: pointer;

  &:hover,
  &:focus-visible,
  &[aria-selected='true'] {
    color: ${({ theme }) => theme.colors.neutral.grey160};
    background-color: ${({ theme }) => theme.colors.brand.green20};
  }
`;

const Destination = styled.span`
  display: block;
  font-weight: 600;
`;

const Duration = styled.time`
  display: block;
  font-size: 0.875rem;
  color: ${({ theme }) => theme.colors.neutral.grey120};
`;

const DeleteButton = styled.button`
  display: block;
  margin: 0;
  padding: 0.75rem;
  border: 0;
  width: 100%;
  font-family: ${({ theme }) => theme.fontFamily.alternate};
  font-size: 1rem;
  font-weight: bold;
  text-align: left;
  color: ${({ theme }) => theme.colors.brand.green140};
  background: none;
  cursor: pointer;

  &:hover,
  &:focus-visible,
  &[aria-selected='true'] {
    color: ${({ theme }) => theme.colors.neutral.grey160};
    background-color: ${({ theme }) => theme.colors.brand.green20};
  }
`;

export {
  Wrapper,
  Headline,
  List,
  ItemButton,
  Destination,
  Duration,
  DeleteButton,
};
